import React from 'react';
import { Loader2 } from 'lucide-react';
import PageBack from '../ui/PageBack';

interface RouteMessageProps {
  title: string;
  detail?: string;
  /** Shows a spinner and announces the message as a status. */
  busy?: boolean;
  onBack?: () => void;
  /** The read failed: the message is announced and offers Try again, as the other failed reads do (`ErrorState`). */
  onRetry?: () => void;
}

/** A dedicated view that cannot show its content yet: loading, not found, or failed to load. */
const RouteMessage: React.FC<RouteMessageProps> = ({ title, detail, busy = false, onBack, onRetry }) => (
  <div className="max-w-xl" role={busy ? 'status' : onRetry ? 'alert' : undefined}>
    {onBack && <PageBack onClick={onBack} />}
    <h1 className="text-xl font-semibold m-0 flex items-center gap-2">
      {busy && <Loader2 className="w-5 h-5 animate-spin text-c3-mute" aria-hidden />}
      {title}
    </h1>
    {detail && <p className="text-c3-mute mt-2">{detail}</p>}
    {onRetry && (
      <button type="button" className="c3-btn c3-btn-ghost c3-btn-sm mt-3" onClick={onRetry}>
        Try again
      </button>
    )}
  </div>
);

export default RouteMessage;
